var React = require('react');

function LinkChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.97604 4.74711V15.3592L14.4562 10.0532L3.97604 4.74711ZM1.807 0.158981L20.07 9.40462C20.2009 9.47111 20.3094 9.56617 20.3849 9.68034C20.4603 9.79451 20.5 9.92383 20.5 10.0554C20.5 10.187 20.4603 10.3164 20.3849 10.4305C20.3094 10.5447 20.2009 10.6398 20.07 10.7063L1.807 19.9519C1.67455 20.019 1.52401 20.0544 1.37066 20.0547C1.21732 20.0549 1.06662 20.02 0.933879 19.9533C0.801138 19.8867 0.691079 19.7908 0.614878 19.6753C0.538678 19.5598 0.49905 19.4289 0.500017 19.2958V0.809041C0.499972 0.676349 0.540272 0.545996 0.616848 0.431143C0.693425 0.31629 0.803565 0.221005 0.93615 0.154907C1.06873 0.0888101 1.21907 0.0542414 1.37197 0.0546918C1.52488 0.0551423 1.67494 0.0905958 1.807 0.157473V0.158981Z"}));
}

LinkChevron.defaultProps = {"viewBox":"0 0 21 21","fill":"none"};

module.exports = LinkChevron;

LinkChevron.default = LinkChevron;
